exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".pressure-tests-specification div.admin-body{padding:27px}.pressure-tests-specification div.admin-body div.header{height:40px}.pressure-tests-specification div.admin-body div.header div.buttons{position:relative;float:right}.pressure-tests-specification div.admin-body h3{margin-top:16px;margin-bottom:8px}\n", ""]);

